(function(){
  var card=document.querySelector('.pcard'), stage=document.querySelector('.stage');
  document.querySelectorAll('.chips .chip').forEach(function(c){
    c.addEventListener('click',function(){
      document.querySelectorAll('.chips .chip').forEach(function(x){x.classList.remove('on')});
      c.classList.add('on');
      var dot=c.querySelector('u');
      var col=dot?getComputedStyle(dot).backgroundColor:null;
      var np=document.getElementById('nowNote'); if(np) np.textContent=c.textContent.trim();
      /* Подсветка сцены задаётся переменной, а не inline-фоном: inline перебил бы
         ночную палитру, и после выбора аромата сцена оставалась бы дневной. */
      if(col&&card){card.style.setProperty('--aura',col);
        if(stage) stage.style.setProperty('--tint', col.replace('rgb(','rgba(').replace(')',',0.16)'));}
    });
  });
})();
/* мобильная панель: тот же .mega, что на десктопе раскрывается по наведению */
(function(){
  var hdr=document.querySelector('.hdr'), burger=hdr&&hdr.querySelector('.burger');
  if(!hdr||!burger) return;
  function set(open){
    hdr.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  burger.addEventListener('click', function(){ set(!hdr.classList.contains('open')); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') set(false); });
  hdr.querySelectorAll('.mega a').forEach(function(a){
    a.addEventListener('click', function(){ set(false); });
  });
  window.addEventListener('resize', function(){ if(window.innerWidth>860) set(false); });
})();
(function(){
  var b=document.getElementById('totop');
  if(!b) return; /* кнопка есть только на главной */
  var onScroll=function(){ b.classList.toggle('show', window.scrollY > 700); };
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  b.addEventListener('click', function(){
    var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top:0, behavior: rm ? 'auto' : 'smooth'});
  });
})();
